import { AppProviders, AppRoutes } from '@/components';
import { TranslationSuspenseDefault as TranslationSuspense } from '@/components/common';
import { queryClient } from '@/lib/queryClient';
import React from 'react';

/**
 * Main App component following KISS and single responsibility principles
 *
 * Responsibilities:
 * - Application layout structure
 * - Provider composition via AppProviders
 * - Route rendering via AppRoutes
 * - Development tools (TokenExpirationInfo)
 *
 * Following React best practices:
 * - Declarative over imperative
 * - DRY (Don't Repeat Yourself)
 * - Single responsibility
 * - Composition over inheritance
 * - Separation of concerns
 */
const App: React.FC = () => {
  return (
    <TranslationSuspense>
      <AppProviders queryClient={queryClient}>
        <div className='min-h-screen bg-background text-foreground'>
          <AppRoutes />
          {/* Token expiration info component (only visible in development) */}
          {/* <TokenExpirationInfo /> */}
        </div>
      </AppProviders>
    </TranslationSuspense>
  );
};

export default App;
